export default {
  REGISTER_EVENT: 'dashboard_register_ok',
};
